import { computed } from 'vue';
import {
  useVueTable,
  getCoreRowModel,
  getPaginationRowModel,
} from '@tanstack/vue-table';
import { useUISettings } from 'dashboard/composables/useUISettings';

export const REPORT_PAGE_SIZES = [25, 50, 100];

export const useReportTablePagination = (rows, settingsKey) => {
  const { uiSettings, updateUISettings } = useUISettings();

  const getPageSize = () => {
    const saved = Number(uiSettings.value[settingsKey]);
    return REPORT_PAGE_SIZES.includes(saved) ? saved : 25;
  };

  const table = useVueTable({
    get data() {
      return rows.value || [];
    },
    columns: [{ id: '_row' }],
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    initialState: {
      pagination: {
        pageSize: getPageSize(),
      },
    },
  });

  const pagedRows = computed(() =>
    table.getRowModel().rows.map(row => row.original)
  );

  const handlePageSizeChange = pageSize => {
    updateUISettings({ [settingsKey]: pageSize });
  };

  return { table, pagedRows, getPageSize, handlePageSizeChange };
};
